module.exports = __webpack_public_path__ + "media/spinner-wheel.80bb2426.webm";